import { useMemo, useState } from "react";
import {
	computeOwnHomeContext,
	type OwnHomeInputs,
} from "web_myplann/Inspiration/Utils/ownHomeMath";

export type OwnHomeSheet =
	| "quick"
	| "expenses"
	| "affordability-edit"
	| "create-goal"
	| null;

export const useOwnHomeJourney = () => {
	const [inputs, setInputs] = useState<OwnHomeInputs>({});
	const [activeSheet, setActiveSheet] = useState<OwnHomeSheet>(null);

	const context = useMemo(() => computeOwnHomeContext(inputs), [inputs]);

	const submitQuick = (data: {
		rent: number;
		income: number;
		savings?: number;
	}) => {
		setInputs((prev) => ({ ...prev, ...data }));
		setActiveSheet(null);
	};

	const submitExpenses = (expenses: number) => {
		setInputs((prev) => ({ ...prev, expenses }));
		setActiveSheet(null);
	};

	const submitAffordabilityEdit = (data: {
		income: number;
		expenses?: number;
	}) => {
		setInputs((prev) => ({ ...prev, ...data }));
		setActiveSheet(null);
	};

	return {
		inputs,
		context,
		activeSheet,
		openSheet: setActiveSheet,
		closeSheet: () => setActiveSheet(null),
		submitQuick,
		submitExpenses,
		submitAffordabilityEdit,
	};
};
